// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__Ro6iG","headline":"default_headline__eF401","line":"default_line__A4ijZ"};